import React, { useEffect, useState } from 'react';
import { Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { getRoutePath } from '../config';
import { indexedDBStorage } from '../services/storage/indexedDB';
import MultiImageUploadFlow, { CapturedItem } from '../components/MultiImageUploadFlow';

// MenuPage で選択した画像を受け渡すための IndexedDB キー
export const UPLOAD_IMAGES_KEY = 'uploadImages';

/**
 * 「画像をアップロードして登録する」フロー。
 * MenuPage でファイル選択（Web）／カメラロール（アプリ）から選んだ画像を、
 * 連続撮影と同じ確認・アップロード画面（MultiImageUploadFlow）で処理する。
 */
const ImageUploadPage: React.FC = () => {
  const navigate = useNavigate();
  // null = 読み込み中
  const [images, setImages] = useState<CapturedItem[] | null>(null);

  useEffect(() => {
    (async () => {
      const json = await indexedDBStorage.getItem(UPLOAD_IMAGES_KEY);
      // 一度読み込んだら破棄（リロード時の二重表示を防ぐ）
      await indexedDBStorage.removeItem(UPLOAD_IMAGES_KEY);
      if (json) {
        try {
          const arr = JSON.parse(json) as CapturedItem[];
          if (Array.isArray(arr) && arr.length > 0) {
            setImages(arr);
            return;
          }
        } catch {
          // パース失敗時はメニューへ
        }
      }
      navigate(getRoutePath('/menu'));
    })();
  }, [navigate]);

  if (!images) {
    return (
      <div
        style={{
          position: 'fixed',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#000',
          zIndex: 1000,
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return (
    <MultiImageUploadFlow
      images={images}
      onChangeImages={setImages}
      onBack={() => navigate(getRoutePath('/menu'))}
      backLabel="戻る"
      onComplete={() => navigate(getRoutePath('/menu'))}
    />
  );
};

export default ImageUploadPage;
